import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../pages/chat/api";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../pages/chat/api";
let activeChatSocket = null;
let shouldStopStreaming = false;
export const fetchPdfChat = createAsyncThunk(
  'pdfChat/fetchPdfChat',
  async ({ pdfKey, clientMessage,chat_module = "document",id}, { rejectWithValue, dispatch }) => {
    let token = await getFreshAccessToken();
    shouldStopStreaming = false;
    if (!token) {
      return rejectWithValue('No authorization token found');
    }

    const wsUrl = `wss://stagingbackend.docusensa.com/ws/qdrant-chat/${pdfKey}/?token=${token}`;
    shouldStopStreaming = false;
    if (activeChatSocket && activeChatSocket.readyState !== WebSocket.CLOSED) {
  activeChatSocket.close();
}
    const socket = new WebSocket(wsUrl);
activeChatSocket = socket;
    return new Promise((resolve, reject) => {
      let accumulatedAnswer = '';
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        socket.send(JSON.stringify({ client_message: clientMessage,chat_module: chat_module,id }));
        dispatch(updateStatus('loading'));
        dispatch(updatePartialAnswer(''));
      };

      socket.onmessage = (event) => {
          if (shouldStopStreaming) {
          console.warn("🛑 shouldStopStreaming is true → Closing WebSocket...");
          socket.close();
          dispatch(updateStatus("stopped")); // Optional UI update
          return;
        }
        

        try {
          const data = JSON.parse(event.data);

          if (
            data.type !== "info" &&
            data.status !== "connected" &&
            data.message
          ) {
            accumulatedAnswer += data.message;
            dispatch(updatePartialAnswer(accumulatedAnswer));
          }

          if (data.type === 'final') {
            botMessageId = data.data.bot_message_id;
            runId = data.data.run_id;
            generatedQuestions = data.data.generated_questions || ""; 
            const sources = data.data.sources || []; 
          
            dispatch(updateGeneratedQuestions(generatedQuestions)); // Update the state with the summary
          
            dispatch(updateFinalAnswer(accumulatedAnswer));
            dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions }));
            dispatch(setSources(sources));
            socket.close();
            resolve(accumulatedAnswer);
          }
        } catch (error) {
          console.error('Error parsing WebSocket message:', event.data, error);
        }
      };

      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
        reject(rejectWithValue('WebSocket connection error'));
      };

      socket.onclose = () => {
      };
    });
  }
);




export const fetchDocumentSummary = createAsyncThunk(
  "chat/fetchDocumentSummary",
  async ({ pdfKey, clientMessage,chat_module = "document"  }, { rejectWithValue, dispatch }) => {
    let token = await getFreshAccessToken();
    if (!token) {
      return rejectWithValue("No authorization token found");
    }

    

    const wsUrl = `wss://stagingbackend.docusensa.com/ws/pdf-summary-and-chats/${pdfKey}/?token=${token}`;

    const socket = new WebSocket(wsUrl);

    return new Promise((resolve, reject) => {
      let accumulatedAnswer = "";
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        socket.send(JSON.stringify({ client_message: clientMessage,chat_module: chat_module }));
        dispatch(updateStatus("loading"));
        dispatch(updatePartialAnswer(""));
      };

      socket.onmessage = (event) => {


        try {
          const message = event.data.startsWith("data: ")
            ? event.data.slice(6)
            : event.data;
          const data = JSON.parse(message);

          if (
            data.type !== "info" &&
            data.status !== "connected" &&
            data.message
          ) {
            accumulatedAnswer += data.message;
            dispatch(updatePartialAnswer(accumulatedAnswer));
          }

          if (data.pdf_details) {
            if (data.pdf_details.example_questions) {
                generatedQuestions = data.pdf_details.example_questions;
                dispatch(updateGeneratedQuestions(generatedQuestions)); 
                dispatch(updateSummaryStatus("succeeded"));

            }

            // Extract and combine user initials
            const firstChar = data.pdf_details.first_char || "";
            const lastChar = data.pdf_details.last_char || "";
            const userInitials = (firstChar + lastChar).trim().toUpperCase() || "N/A";

            dispatch(updateUserInitials(userInitials)); 
        }


          if (data.type === "final") {
            
            botMessageId = data.data.bot_message_id;
            runId = data.data.run_id;
            const summary = data.data.summary || "";
            generatedQuestions = data.data.example_questions || ""; 
            
       

            // Extract and format timestamp
            let formattedTimestamp = "N/A";
            if (data.data.summary_generated_at) {
              try {
                formattedTimestamp = new Date(data.data.summary_generated_at).toLocaleString("en-US", {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                });
              } catch (error) {
                console.error("Error parsing summary_generated_at:", error);
              }
            }

       

         


            dispatch(updateFinalSummary(summary));
            dispatch(updateGeneratedQuestions(generatedQuestions)); 
            dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions }));

            if (generatedQuestions) {
              dispatch(updateSummaryStatus("succeeded"));
          }
            socket.close();
            resolve(summary);
          }
        } catch (error) {
          console.error("Error parsing WebSocket message:", event.data, error);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
        reject(rejectWithValue("WebSocket connection error"));
      };

      socket.onclose = () => {
      };
    });
  }
);




const pdfChatSlice = createSlice({
  name: 'pdfChat',
  initialState: {
    messages: [],
    partialAnswer: '',
    finalAnswer: '',
    status: 'idle',
    error: null,
    botMessageId: null, 
    runId: null,
    generatedQuestions: null,
    feedback: {},
    formattedTimestamp: "",
    userInitials: "",
    summaryStatus: "idle",
  },
  initialState: {
    messages: [],
    partialAnswer: "",
    finalAnswer: "",
    partialSummary: "",
    finalSummary: "",
    status: "idle",
    summaryStatus: "idle",
    error: null,
    summaryError: null,
    botMessageId: null,
    runId: null,
    generatedQuestions: null,
    feedback: {},
    formattedTimestamp: "",
    userInitials: "",
  },
  reducers: {
    resetPdfChatState: (state) => {
      state.messages = [];
      state.partialAnswer = '';
      state.finalAnswer = '';
      state.status = 'idle';
      state.error = null;
      state.botMessageId = null; 
      state.runId = null;
      state.generatedQuestions = null;
      state.feedback = {}; 
    },
    updatePartialAnswer: (state, action) => {
      state.partialAnswer = action.payload;
    },
    updateFinalAnswer: (state, action) => {
      state.finalAnswer = action.payload;
    },
    updateBotMessageInfo: (state, action) => {
      const { botMessageId, runId , generatedQuestions } = action.payload;
      state.botMessageId = botMessageId;
      state.runId = runId;
      state.generatedQuestions = generatedQuestions; 
    },
    updateFeedback: (state, action) => {
      const { messageId, feedbackType } = action.payload;
      state.feedback[messageId] = feedbackType;
    },
    updateUserInitials: (state, action) => { // <-- Define this action
      state.userInitials = action.payload;
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
    },
    updatePartialSummary: (state, action) => {
      state.partialSummary = action.payload;
    },
    updateFinalSummary: (state, action) => {
      state.finalSummary = action.payload;
    },
    updateSummaryStatus: (state, action) => {
      state.summaryStatus = action.payload;
    },
    setSources: (state, action) => {
      state.sources = action.payload || [];
    },
    updateGeneratedQuestions: (state, action) => {
      state.generatedQuestions = action.payload; 
    },
  
    updateSummaryMetadata: (state, action) => {
    
      if (action.payload) {
        state.formattedTimestamp = action.payload.formattedTimestamp ? action.payload.formattedTimestamp : "N/A";
        state.userInitials = action.payload.userInitials ? action.payload.userInitials : "N/A";
      }
    },
    resetStopStreaming: (state) => {
        shouldStopStreaming = false;
      },
      stopStreaming: (state) => {
      shouldStopStreaming = true;
    }
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPdfChat.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPdfChat.fulfilled, (state, action) => {
        state.messages.push(action.payload);
        state.status = 'succeeded';
      })
      .addCase(fetchDocumentSummary.pending, (state) => {
        state.summaryStatus = "loading";
      })
      .addCase(fetchDocumentSummary.fulfilled, (state) => {
        state.summaryStatus = "succeeded";
      })
      .addCase(fetchDocumentSummary.rejected, (state, action) => {
        state.summaryError = action.payload;
        state.summaryStatus = "failed";
      })
      .addCase(fetchPdfChat.rejected, (state, action) => {
        state.error = action.payload;
        state.status = 'failed';
      });
  },
});
export const { resetPdfChatState, updatePartialAnswer, updatePartialSummary,updateUserInitials,
  updateFinalSummary,
  updateSummaryStatus,
  updateGeneratedQuestions, updateFinalAnswer,  stopStreaming,
  resetStopStreaming,updateBotMessageInfo, updateStatus,updateSummaryMetadata, setSources,} = pdfChatSlice.actions;
export default pdfChatSlice.reducer;